import { Formik } from "formik";
import Card from "../Card";
import Input from "../Input";
import {
  appSettingValidationSchema,
  editCompanyValidationSchema,
  validationSchema,
} from "./form-validation";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import AutoCompleteAddress from "../AutoCompleteAddress";
import ToggleButton from "../ToggleButton";
import ToggleSwitch from "../ToggleSwaitch";

const AppSettingForm = ({
  initialValues,
  handleSave,
  formikRef,
  type,
  loadingState,
  loading,
}) => {
  return (
    <div id="company-form" className="py-6">
      <Card>
        <Formik
          innerRef={formikRef}
          initialValues={initialValues}
          enableReinitialize={true}
          validationSchema={appSettingValidationSchema}
          onSubmit={async (values, resetForm) => {
            handleSave(values, resetForm);
          }}
        >
          {({
            values,
            isSubmitting,
            handleChange,
            touched,
            errors,
            handleSubmit,
          }) => (
            <form onSubmit={handleSubmit}>
              <div className="p-6">
                <div className="flex flex-col gap-6 md:flex-row">
                  <div className="flex flex-col gap-6 w-full md:w-1/2">
                    <h3 className="text-lg font-medium text-primary">
                      IOS Setting
                    </h3>

                    {console.log(values)}
                    <div className="w-full">
                      <Input
                        label={"Version"}
                        name="iosVersion"
                        value={values["iosVersion"]}
                        onChange={handleChange}
                        type="text"
                        error={errors.iosVersion}
                        placeholder={"Enter IOS Version"}
                      />
                    </div>

                    <div className="w-full">
                      <ToggleSwitch
                        label={"Force Update"}
                        name="iosForceUpdatable"
                        checked={values["iosForceUpdatable"]}
                        onChange={handleChange}
                        error={errors.iosForceUpdatable}
                      />
                    </div>
                  </div>

                  <div className="flex flex-col gap-6 w-full md:w-1/2">
                    <h3 className="text-lg font-medium text-primary">
                      Android Setting
                    </h3>

                    <div className="w-full">
                      <Input
                        label={"Version"}
                        name="androidVersion"
                        value={values["androidVersion"]}
                        onChange={handleChange}
                        type="text"
                        error={errors.androidVersion}
                        placeholder={"Enter Android Version"}
                      />
                    </div>

                    <div className="w-full">
                      <ToggleSwitch
                        label={"Force Update"}
                        name="androidForceUpdatable"
                        checked={values["androidForceUpdatable"]}
                        onChange={handleChange}
                        error={errors.androidForceUpdatable}
                      />
                    </div>
                  </div>
                </div>

                <div className="mt-6 flex justify-end space-x-2">
                  <button
                    type="submit"
                    disabled={loading}
                    className="flex w-[200px] justify-center rounded bg-primary p-3 font-medium text-white hover:opacity-90 h-[50px]"
                  >
                    {loading ? (
                      <Spin
                        style={{
                          color: "white",
                        }}
                        indicator={
                          <LoadingOutlined style={{ fontSize: 24 }} spin />
                        }
                      />
                    ) : (
                      "Save"
                    )}
                  </button>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </Card>
    </div>
  );
};

export default AppSettingForm;
